import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function FindReportCustomerDropDowns({
  formData,
  setFormData,
  handleInputChange,
}) {
  /*   All States
   ********************************************* */
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [taxRateList, setTaxRateList] = useState(null);
  const [locationList, setLocationList] = useState(null);

  const loadingOn = () => {
    setLoading(true);
  };
  const loadingOff = () => {
    setLoading(false);
  };

  /*   All Functions
   ********************************************* */

  const getCustomerDropDowns = async () => {
    try {
      loadingOn();
      const { data } = await API.get("/customer/dropdowns", {
        headers: authHeader(),
      });
      if (data?.type === "success") {
        setTaxRateList(data?.result?.taxRateList);
        setLocationList(data?.result?.locationList);
      }
      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    getCustomerDropDowns();
  }, []);
  return (
    <div className="col-6 flex-grow-1 px-3 py-2 my-1">
      {loading && <Spinner />}
      {/* State */}

      <div className="flex-grow-1 row mb-1">
        <div className="col-4 flex-center justify-content-start align-items-center">
          <label htmlFor={"addressState"}>State</label>
        </div>
        <div className="col-8">
          <input
            name={"addressState"}
            type={"text"}
            value={formData?.addressState || ""}
            onChange={(e) => {
              handleInputChange(e, "text");
            }}
            className="form-control form-control-sm w-100"
            placeholder={`🔎 state`}
          />
        </div>
      </div>
      <div className="flex-grow-1 row mb-1">
        <div className="col-4 flex-center justify-content-start align-items-center">
          <label htmlFor={"locationId"}>Location</label>
        </div>
        <div className="col-8">
          <div className="d-flex align-items-center">
            <select
              name="locationId"
              className="form-select"
              value={formData?.locationId}
              onChange={(e) => {
                handleInputChange(e, "number");
              }}
            >
              <option value="">None</option>
              {locationList?.map((item) => (
                <option key={item?.id} value={item?.id}>
                  {item?.locationName}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="flex-grow-1 row mb-1">
        <div className="col-4 flex-center justify-content-start align-items-center">
          <label htmlFor={"taxAccountId"}>Tax Rate</label>
        </div>
        <div className="col-8">
          <div className="d-flex align-items-center">
            <select
              name="taxAccountId"
              className="form-select"
              value={formData?.taxAccountId}
              onChange={(e) => {
                handleInputChange(e, "number");
              }}
            >
              <option value="">None</option>
              {taxRateList?.map((item) => (
                <option key={item?.id} value={item?.id}>
                  {item?.taxAccountName} - {item?.taxRate}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {/* Tax Exempted */}
      <div className="flex-grow-1 row mb-1">
        <div className="col-4 flex-center justify-content-start align-items-center">
          <label htmlFor="isTaxExamption">Tax Exempted</label>
        </div>
        <div className="col-8">
          <div className="d-flex align-items-center">
            <select
              name="isTaxExamption"
              className="form-select"
              value={
                formData?.isTaxExamption
                  ? "true"
                  : formData?.isTaxExamption === false
                  ? "false"
                  : ""
              }
              onChange={(e) => {
                handleInputChange(e, "boolean");
              }}
            >
              <option value="">None</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </div>
        </div>
      </div>

      {/* Exemption File */}
      <div className="flex-grow-1 row mb-1">
        <div className="col-4 flex-center justify-content-start align-items-center">
          <label htmlFor="examptionFile">Exemption Certificate on file</label>
        </div>
        <div className="col-8">
          <div className="d-flex align-items-center">
            <select
              name="examptionFile"
              className="form-select"
              value={
                formData?.examptionFile === true
                  ? "true"
                  : formData?.examptionFile === false
                  ? "false"
                  : ""
              }
              onChange={(e) => {
                handleInputChange(e, "boolean");
              }}
            >
              <option value="">None</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
